import TpEvaluatorSearchParams from './TpEvaluatorSearchParams';

export default class TpEvaluatorEmailCampaignSearchParams extends TpEvaluatorSearchParams {
  additionalInitialization() {
    this.TypeOfExport = 'EmailCampaignExport';
    this.Status = 'Contact';
    this.EmailOptOut = false;
    this.EmailOptOutPlaceholder = 'No';
    this.EmailVerified = true;
    this.EmailVerifiedPlaceholder = 'Yes';
    this.IncludeSelfDeactivated = false;
    this.IncludeSelfDeactivatedPlaceholder = 'No';
    this.TextAllow = null;
    this.TextAllowPlaceholder = null;
    this.IncludeNATextMessageAuthorized = null;
    this.IncludeNATextMessageAuthorizedPlaceholder = null;
  }
}
